import PropTypes from "prop-types";
import { isNil } from "ramda";

import Presenter from "utils/PropTypesPresenter";

export default new Presenter(
  {
    id: PropTypes.string,
    type: PropTypes.string,
    title: PropTypes.string,
    query: PropTypes.string,
    displayName: PropTypes.string,
    description: PropTypes.string,
    backgroundColor: PropTypes.string,
    metaDescription: PropTypes.string,
    metaKeywords: PropTypes.string,
    metaTitle: PropTypes.string,
    indexable: PropTypes.string,
    footer: PropTypes.shape({}),
  },
  {
    renderCategoryName(c) {
      if (isNil(c?.displayName)) return "All";

      const name = c.displayName;
      return name.toLowerCase().includes("ecards") ? `All ${name}` : `All ${name} Ecards`;
    },

    isCumpleanos(c) {
      return c?.id === "cumpleanos";
    },
  },
);
